import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";
import {
  DATE_OF_BIRTH_SCHEMA_FIELD_NAME,
  GENDER_SCHEMA_FIELD_NAME,
  getDateOfBirthFormFieldSchema,
  getGenderFormFieldSchema,
  getNameFormFieldsSchema,
} from "@swa-ui/personal-info";

import {
  getRapidRewardsNumberFormFieldSchema,
  RAPID_REWARDS_NUMBER_SCHEMA_FIELD_NAME,
} from "../RapidRewardsNumberFormField";

export const ASSOCIATED_ADULT_SCHEMA_FIELD_NAME = "associatedAdult";

export const getPersonalInfoFormFieldsSchema = (fieldNames = {}) => {
  const {
    associatedAdult = ASSOCIATED_ADULT_SCHEMA_FIELD_NAME,
    dateOfBirth = DATE_OF_BIRTH_SCHEMA_FIELD_NAME,
    gender = GENDER_SCHEMA_FIELD_NAME,
    rapidRewardsNumber = RAPID_REWARDS_NUMBER_SCHEMA_FIELD_NAME,
  } = fieldNames;

  return {
    ...getNameFormFieldsSchema(fieldNames),
    [associatedAdult]: yup.string().when("$lapChild", {
      is: true,
      otherwise: yup.string().optional(),
      then: yup
        .string()
        .required()
        .label(i18n("PersonalInfoFormFields__ASSOCIATED_ADULT_LABEL")?.toLowerCase()),
    }),
    [dateOfBirth]: getDateOfBirthFormFieldSchema(),
    [gender]: getGenderFormFieldSchema(),
    [rapidRewardsNumber]: yup.string().when("$lapChild", {
      is: true,
      otherwise: getRapidRewardsNumberFormFieldSchema(),
      then: yup.string().optional(),
    }),
  };
};
